<template>
  <Layout
    :title="title"
    :items="items"
  >
    <b-card no-body>
      <template #header>
        <h4 class="card-title">
          {{ unitDetail.name }}
        </h4>
      </template>
      <b-card-body class="px-0 px-md-3">
        <b-nav
          tabs
          class="mt-1"
        >
          <b-nav-item
            :active="selectedMode == 'demand'"
            @click="selectedMode = 'demand'"
          >
            <span class="fw-bold">
              DEMAND
            </span>
          </b-nav-item>
          <b-nav-item
            :active="selectedMode == 'supply'"
            @click="selectedMode = 'supply'"
          >
            <span class="fw-bold">
              SUPPLY
            </span>
          </b-nav-item>
          <b-nav-item
            :active="selectedMode == 'total'"
            @click="selectedMode = 'total'"
          >
            <span class="fw-bold">
              TOTAL CONSUMED
            </span>
          </b-nav-item>
        </b-nav>

        <div
          class="p-3 mb-3"
          style="background-color: #eff2f7"
        >
          <div
            class="d-md-flex mb-4"
            style="border-bottom: 2px solid #009688"
          >
            <b-col
              md="4"
              class="d-flex mb-2 mb-md-0"
            >
              <div
                v-if="!isLoggedIn"
                class="fw-bold my-auto"
              >
                {{ dateLabel }}
              </div>
              <b-dropdown
                v-else
                variant="white"
                class="border border-4 border-top-0 border-end-0 border-bottom-0 border-tosca shadow-sm mb-2"
                menu-class="custom-dropdown-height"
              >
                <template v-slot:button-content>
                  <div class="fw-bold">
                    <span style="margin: 0px 8px">
                      {{ dateLabel }}
                    </span>
                    <i class="mdi mdi-chevron-down" />
                  </div>
                </template>

                <b-dropdown-item
                  v-for="(option, index) in startDateOptions"
                  :key="index"
                  :active="startDate == option.value"
                  @click="startDate = option.value"
                >
                  {{ option.label }}
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col
              md="4"
              class="pe-md-5 pb-3 pb-md-0"
            >
              <b-button-group class="h-100 w-100">
                <b-button
                  :variant="selectedTimeWindow == 'day' ? 'tosca' : 'light'"
                  class="fw-bold shadow-sm"
                  style="width: 200px"
                  @click="selectedTimeWindow = 'day'"
                >
                  {{ isLoggedIn ? 'Daily' : 'Today' }}
                </b-button>
                <b-button
                  :variant="selectedTimeWindow == 'month' ? 'tosca' : 'light'"
                  class="fw-bold shadow-sm"
                  style="width: 200px"
                  @click="selectedTimeWindow = 'month'"
                >
                  {{ isLoggedIn ? 'Monthly' : 'This Month' }}
                </b-button>
                <b-button
                  :variant="selectedTimeWindow == 'year' ? 'tosca' : 'light'"
                  class="fw-bold shadow-sm"
                  style="width: 200px"
                  @click="selectedTimeWindow = 'year'"
                >
                  {{ isLoggedIn ? 'Yearly' : 'This Year' }}
                </b-button>
              </b-button-group>
            </b-col>
            <b-col
              md="4"
              class="ps-md-5"
            >
              <b-button-group class="h-100 w-100">
                <b-button
                  :variant="selectedPayloadKey == 'peak power' ? 'tosca' : 'light'"
                  class="fw-bold shadow-sm"
                  style="width: 200px"
                  @click="selectedPayloadKey = 'peak power'"
                >
                  Peak Power
                </b-button>
                <b-button
                  :variant="selectedPayloadKey == 'energy' ? 'tosca' : 'light'"
                  class="fw-bold shadow-sm"
                  style="width: 200px"
                  @click="selectedPayloadKey = 'energy'"
                >
                  Energy
                </b-button>
              </b-button-group>
            </b-col>
          </div>

          <div class="mb-3">
            <b-dropdown
              variant="white"
              class="border border-4 border-top-0 border-end-0 border-bottom-0 border-tosca shadow-sm mb-2"
              menu-class="custom-dropdown-height"
            >
              <template v-slot:button-content>
                <div class="fw-bold">
                  <i class="mdi mdi-filter-variant" />
                  <span style="margin: 0px 8px">
                    Sort : {{ selectedSortLabel }}
                  </span>
                  <i class="mdi mdi-chevron-down" />
                </div>
              </template>

              <b-dropdown-item
                v-for="option in sortOptions"
                :key="option.value"
                :active="sortBy == option.value"
                @click="sortBy= option.value"
              >
                {{ option.label }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <template
            v-for="block in sortedbuildings"
          >
            <UnitDetailCard
              :key="block.id"
              :building-detail="block"
              :selected-mode="selectedMode"
              :start-date="startDate"
              :end-date="endDate"
              :time-window="selectedTimeWindow"
              :payload-key="selectedPayloadKey"
              @updateValue="updateValue"
            />
          </template>
        </div>
      </b-card-body>
    </b-card>
  </Layout>
</template>

<script>
import {
  format, addDays, addMonths, addYears, startOfDay, startOfMonth, startOfYear, endOfDay, endOfMonth, endOfYear,
} from 'date-fns';
import { TokenService } from '@/services/local-storage';
import appConfig from '@/app.config';
import Layout from '@/layouts/main';
import UnitDetailCard from './UnitDetailCard.vue';

export default {
  page: {
    title: 'Detail',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout, UnitDetailCard,
  },

  data() {
    return {
      isLoading: false,
      unitDetail: {
        blocks: [],
      },
      selectedMode: 'demand',
      selectedTimeWindow: 'day',
      selectedPayloadKey: 'peak power',
      sortBy: 'nameAscending',
      blockTotalValue: [],
      startDate: startOfDay(new Date()),
    };
  },
  computed: {
    isLoggedIn() {
      return !!TokenService.get();
    },
    unitId() {
      return this.$route.params.unitId;
    },
    selectedOrganizationDetail() {
      return this.$store.state.organization.selectedOrganizationDetail;
    },
    dateLabel() {
      if (this.selectedTimeWindow === 'day') return format(this.startDate, 'EEEE, dd MMM yyyy');
      if (this.selectedTimeWindow === 'month') return format(this.startDate, 'MMMM yyyy');
      if (this.selectedTimeWindow === 'year') return format(this.startDate, 'yyyy');
      return 'Select Timerange';
    },
    endDate() {
      if (this.selectedTimeWindow == 'day') {
        return endOfDay(this.startDate);
      } if (this.selectedTimeWindow == 'month') {
        return endOfMonth(this.startDate);
      } if (this.selectedTimeWindow == 'year') {
        return endOfYear(this.startDate);
      } return '';
    },
    title() {
      return this.unitDetail.name;
    },
    items() {
      return [
        {
          text: 'HOME',
          to: '/home',
        },
        {
          text: this.selectedOrganizationDetail?.name ?? '',
          to: '/campus-map',
        },
        {
          text: this.unitDetail?.name ?? '',
          active: true,
        },
      ];
    },
    sortOptions() {
      return [
        { value: 'nameAscending', label: 'Building Name A -> Z' },
        { value: 'nameDescending', label: 'Building Name Z -> A' },
        { value: 'valueAscending', label: 'Lowest Value -> Highest Value' },
        { value: 'valueDescending', label: 'Highest Value -> Lowest Value' },
      ];
    },
    startDateOptions() {
      const today = startOfDay(new Date());
      const thisMonth = startOfMonth(new Date());
      const thisYear = startOfYear(new Date());
      if (this.selectedTimeWindow == 'day') {
        return [
          { value: today, label: format(today, 'EEEE, dd MMM yyyy') },
          { value: addDays(today, -1), label: format(addDays(today, -1), 'EEEE, dd MMM yyyy') },
          { value: addDays(today, -2), label: format(addDays(today, -2), 'EEEE, dd MMM yyyy') },
        ];
      } if (this.selectedTimeWindow == 'month') {
        return [
          { value: thisMonth, label: format(thisMonth, 'MMMM yyyy') },
          { value: addMonths(thisMonth, -1), label: format(addMonths(thisMonth, -1), 'MMMM yyyy') },
          { value: addMonths(thisMonth, -2), label: format(addMonths(thisMonth, -2), 'MMMM yyyy') },
        ];
      } return [
        { value: thisYear, label: format(thisYear, 'yyyy') },
        { value: addYears(thisYear, -1), label: format(addYears(thisYear, -1), 'yyyy') },
        { value: addYears(thisYear, -2), label: format(addYears(thisYear, -2), 'yyyy') },
      ];
    },
    selectedSortLabel() {
      return this.sortOptions.find((option) => option.value == this.sortBy).label ?? '';
    },
    sortedbuildings() {
      const buildings = this.unitDetail.blocks;
      buildings.forEach((building) => {
        const totalValue = this.blockTotalValue.find((item) => item.id == building.id);
        building.value = totalValue ? totalValue.value : 0;
      });
      if (this.sortBy == 'nameAscending') {
        return buildings.sort((a, b) => a.name.localeCompare(b.name));
      }
      if (this.sortBy == 'nameDescending') {
        return buildings.sort((a, b) => b.name.localeCompare(a.name));
      }
      if (this.sortBy == 'valueAscending') {
        return buildings.sort((a, b) => Number(a.value) - Number(b.value));
      }
      return buildings.sort((a, b) => Number(b.value) - Number(a.value));
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.getUnitDetail();
      },
    },
    selectedTimeWindow: {
      immediate: true,
      handler() {
        this.startDate = this.startDateOptions[0].value;
      },
    },
  },
  methods: {
    async getUnitDetail() {
      try {
        this.isLoading = true;
        const { data } = await this.$api.getUnitDetail(this.unitId);
        this.unitDetail = data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    updateValue(data) {
      const previousData = this.blockTotalValue.find((item) => item.id == data.id);
      if (previousData) { // if data exist, replace with new value
        this.blockTotalValue.find((item) => item.id == data.id).value = data.value;
      } else { // if data does not exist, create new data
        this.blockTotalValue.push(data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-light {
    background-color: white;
}
</style>
